/**
 * @generated SignedSource<<da8ac6cd97fe68e1888eefc7ba44a438>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type Step1SelectWorkflowGetBuildkitePipelineInputsQuery$variables = {
  integrationId: any;
  orgSlug: string;
  pipelineSlug: string;
};
export type Step1SelectWorkflowGetBuildkitePipelineInputsQuery$data = {
  readonly getBuildkitePipelineInputs: any;
};
export type Step1SelectWorkflowGetBuildkitePipelineInputsQuery = {
  response: Step1SelectWorkflowGetBuildkitePipelineInputsQuery$data;
  variables: Step1SelectWorkflowGetBuildkitePipelineInputsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "integrationId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "orgSlug"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pipelineSlug"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "integrationId",
        "variableName": "integrationId"
      },
      {
        "kind": "Variable",
        "name": "orgSlug",
        "variableName": "orgSlug"
      },
      {
        "kind": "Variable",
        "name": "pipelineSlug",
        "variableName": "pipelineSlug"
      }
    ],
    "kind": "ScalarField",
    "name": "getBuildkitePipelineInputs",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Step1SelectWorkflowGetBuildkitePipelineInputsQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Step1SelectWorkflowGetBuildkitePipelineInputsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a5ed28439b90a84d37ce580fb3bbe59c",
    "id": null,
    "metadata": {},
    "name": "Step1SelectWorkflowGetBuildkitePipelineInputsQuery",
    "operationKind": "query",
    "text": "query Step1SelectWorkflowGetBuildkitePipelineInputsQuery(\n  $integrationId: GlobalID!\n  $orgSlug: String!\n  $pipelineSlug: String!\n) {\n  getBuildkitePipelineInputs(integrationId: $integrationId, orgSlug: $orgSlug, pipelineSlug: $pipelineSlug)\n}\n"
  }
};
})();

(node as any).hash = "1f085eb1a0b46013d58f1fafd2e5c7d4";

export default node;
